/**
 * Phase 6 · the deal screens' strings — the `generate` part. Spread into `HU` and `EN` in
 * `../catalogue.ts`; a key in one and not the other is a type error there.
 */
export const HU = {
  /* ── the frame ── */
  'dealGenerate.title': 'Generálás — {deal}',
  'dealGenerate.titleAgain': 'További generálás — {deal}',
  'dealGenerate.description':
    'A deal megmarad — mellette létrejön a valóság, és visszamutat a dealre.',
  'dealGenerate.steps': 'Lépések',
  'dealGenerate.step.route': 'Mit hozunk létre?',
  'dealGenerate.step.project': 'Projekt',
  'dealGenerate.step.contract': 'Szerződés és sortételek',
  'dealGenerate.step.resources': 'Erőforrás',
  'dealGenerate.next': 'Tovább',
  'dealGenerate.submit': 'Generálás',
  'dealGenerate.running': 'Generálás…',
  'dealGenerate.searchPerson': 'Keresés névre…',

  /* ── 1 · what ── */
  'dealGenerate.route.both.name': 'Projekt és szerződés',
  'dealGenerate.route.both.when': 'Új munka, saját delivery.',
  'dealGenerate.route.both.what':
    'Projekt + szerződés + sortételek + mérföldkő-feladatok + allokációk.',
  'dealGenerate.route.contract.name': 'Csak szerződés',
  'dealGenerate.route.contract.when': 'Meglévő projektbe fut be, vagy nincs benne munka.',
  'dealGenerate.route.contract.what':
    'Szerződés (meglévő projekt alá vagy projekt nélkül) + sortételek.',
  'dealGenerate.route.project.name': 'Csak projekt',
  'dealGenerate.route.project.when': 'Belső vagy pénzügy nélküli munka.',
  'dealGenerate.route.project.what':
    'Csak a projekt. Feladat és allokáció szerződés-sortételhez kötődik, így ezek nem jönnek létre.',
  'dealGenerate.target.label': 'Hova kerüljön a szerződés?',
  'dealGenerate.target.project': 'Meglévő projekthez',
  'dealGenerate.target.none': 'Projekt nélkül, a céghez',
  'dealGenerate.target.noneNote':
    'Projekt nélkül a sortételek a céghez kerülnek, de feladat és allokáció nem jön létre.',
  'dealGenerate.converted.title': 'Ez a deal már generált:',
  'dealGenerate.converted.project': 'Projekt: {name}',
  'dealGenerate.converted.contract': 'Szerződés: {name}',
  'dealGenerate.converted.hint':
    'Amit most választasz, az mellé jön létre — a már meglévőt ne generáld újra.',

  /* ── 2 · project ── */
  'dealGenerate.project.name': 'Projekt neve',
  'dealGenerate.project.code': 'Kód',
  'dealGenerate.project.codePlaceholder': 'pl. ROS-2026-02',
  'dealGenerate.project.client': 'Cég',
  'dealGenerate.project.clientLocked': 'A dealből, zárolva.',
  'dealGenerate.project.pm': 'PM',
  'dealGenerate.project.status': 'Státusz',
  'dealGenerate.project.statusNote': 'Aktívként jön létre.',
  'dealGenerate.project.period':
    'Kezdés és vég a kiválasztott sortételek első és utolsó napjából: {period}. A csapat a 4. lépés párosításából áll össze.',
  'dealGenerate.project.periodNone':
    'A kiválasztott sortételeken nincs dátum: a projekt ma kezdődik, a vége nyitott. A csapat a 4. lépés párosításából áll össze.',
  'dealGenerate.existing.label': 'Projekt',
  'dealGenerate.existing.pick': 'Válassz projektet',
  'dealGenerate.existing.note': 'A deal cégének projektjei.',
  'dealGenerate.existing.empty':
    'A cégnek nincs projektje. Lépj vissza, és válaszd a „Projekt nélkül, a céghez” lehetőséget.',

  /* ── 3 · contract and line items ── */
  'dealGenerate.contract.type': 'Szerződés típusa',
  'dealGenerate.contract.typeNote': 'A bevételi ütem szerint előre kitöltve: {mode}.',
  'dealGenerate.contract.name': 'Szerződés neve',
  'dealGenerate.lines.col.line': 'Deal-sortétel',
  'dealGenerate.lines.col.type': 'Típus',
  'dealGenerate.lines.col.target': 'Szerződés-sortétel',
  'dealGenerate.lines.col.hours': 'Óra',
  'dealGenerate.lines.col.amount': 'Összeg',
  'dealGenerate.lines.option': 'opció',
  'dealGenerate.lines.skipped': 'kihagyva',
  'dealGenerate.lines.folded': 'Mérföldkő: {name}',
  'dealGenerate.lines.toggle': 'Átveszem: {name}',
  'dealGenerate.lines.empty': 'A dealen nincs sortétel — a szerződés sortételek nélkül jön létre.',
  'dealGenerate.milestones.title': 'Mérföldkövek: {count}',
  'dealGenerate.milestones.asLineItems': 'Mérföldkő = szerződés-sortétel',
  'dealGenerate.milestones.asTasks':
    'Mérföldkő = feladat a projektben (0 becslés, határidő a dátum)',
  'dealGenerate.milestones.tasksNeedProject':
    'Ezen az úton nincs projekt, így mérföldkő-feladat sem jön létre.',
  'dealGenerate.preview':
    '1 szerződés ({type}) · sortétel: {lines} · Σ {revenue} bevétel · Σ {hours} becslés.',

  /* ── 4 · resources ── */
  'dealGenerate.match.empty':
    'Nincs placeholder a dealen — allokáció nem jön létre. A projekt Erőforrás fülén később betervezheted a munkát.',
  'dealGenerate.match.pick': 'Válassz embert',
  'dealGenerate.match.aria': 'Ki veszi át: {name}',
  'dealGenerate.match.headcount': '{count} fő',
  'dealGenerate.match.sum':
    'Párosítva: {people} ember · {hours} allokáció. Kemény foglalás, hétfőtől péntekig, a tervezett heteken; a párosítatlan placeholder nem kap foglalást.',
  'dealGenerate.match.noProject':
    'Ezen az úton nincs projekt, így allokáció sem jön létre — a párosítás nem jön át.',
  'dealGenerate.match.projectOnly':
    'Csak projekt: az allokáció szerződés-sortételhez kötődik, így nem jön létre. A projekt Erőforrás fülén később betervezheted a munkát.',
  'dealGenerate.summary.title': 'Mi jön létre?',
  'dealGenerate.summary.project': 'Projekt',
  'dealGenerate.summary.projectExisting': 'Meglévő: {name}',
  'dealGenerate.summary.projectNone': 'Nincs — a céghez',
  'dealGenerate.summary.contract': 'Szerződés',
  'dealGenerate.summary.contractValue': '{type} · sortétel: {lines}',
  'dealGenerate.summary.revenue': 'Bevétel',
  'dealGenerate.summary.estimate': 'Becslés',
  'dealGenerate.summary.tasks': 'Mérföldkő-feladat',
  'dealGenerate.summary.allocations': 'Allokáció',
  'dealGenerate.summary.people': '{count} ember',
  'dealGenerate.summary.pieces': '{count} db',
  'dealGenerate.summary.stepwise':
    'A részek egymás után készülnek: ha valamelyik elakad, ami addig elkészült, megmarad és a dealhez kötődik.',

  /* ── refusals and the outcome ── */
  'dealGenerate.error.project': 'Add meg a projekt nevét és a PM-et.',
  'dealGenerate.error.existing': 'Válassz projektet.',
  'dealGenerate.error.contract': 'Add meg a szerződés nevét.',
  'dealGenerate.partial.title': 'Ami elkészült, megmaradt, és a dealhez kötődik:',
  'dealGenerate.partial.none': 'Semmi nem jött létre.',
  'dealGenerate.partial.hint':
    'A hiányzó részt a További generálással pótolhatod — a már meglévőt ne generáld újra.',
  'dealGenerate.done.title': 'Elkészült — {deal}',
  'dealGenerate.done.lead': 'A deal megmarad, és visszamutat arra, ami létrejött.',
  'dealGenerate.done.project': 'Projekt',
  'dealGenerate.done.openProject': 'Projekt megnyitása',
  'dealGenerate.done.contract': 'Szerződés',
  'dealGenerate.done.openContract': 'Szerződés megnyitása',
  'dealGenerate.done.lineItems': 'Szerződés-sortétel',
  'dealGenerate.done.tasks': 'Mérföldkő-feladat',
  'dealGenerate.done.allocations': 'Heti foglalás',
} as const;

export const EN: Record<keyof typeof HU, string> = {
  'dealGenerate.title': 'Generate — {deal}',
  'dealGenerate.titleAgain': 'Generate more — {deal}',
  'dealGenerate.description':
    'The deal stays — the real thing is created beside it, and points back to the deal.',
  'dealGenerate.steps': 'Steps',
  'dealGenerate.step.route': 'What do we create?',
  'dealGenerate.step.project': 'Project',
  'dealGenerate.step.contract': 'Contract and line items',
  'dealGenerate.step.resources': 'Resources',
  'dealGenerate.next': 'Next',
  'dealGenerate.submit': 'Generate',
  'dealGenerate.running': 'Generating…',
  'dealGenerate.searchPerson': 'Search by name…',

  'dealGenerate.route.both.name': 'Project and contract',
  'dealGenerate.route.both.when': 'New work, our own delivery.',
  'dealGenerate.route.both.what':
    'Project + contract + line items + milestone tasks + allocations.',
  'dealGenerate.route.contract.name': 'Contract only',
  'dealGenerate.route.contract.when': 'It lands in an existing project, or carries no work.',
  'dealGenerate.route.contract.what':
    'Contract (under an existing project or without one) + line items.',
  'dealGenerate.route.project.name': 'Project only',
  'dealGenerate.route.project.when': 'Internal work, or work without finances.',
  'dealGenerate.route.project.what':
    'Only the project. Tasks and allocations hang off a contract line item, so none are created.',
  'dealGenerate.target.label': 'Where does the contract go?',
  'dealGenerate.target.project': 'Under an existing project',
  'dealGenerate.target.none': 'No project, under the client',
  'dealGenerate.target.noneNote':
    'Without a project the line items go under the client, but no tasks or allocations are created.',
  'dealGenerate.converted.title': 'This deal has already been generated:',
  'dealGenerate.converted.project': 'Project: {name}',
  'dealGenerate.converted.contract': 'Contract: {name}',
  'dealGenerate.converted.hint':
    'What you choose now is created beside it — do not generate what already exists again.',

  'dealGenerate.project.name': 'Project name',
  'dealGenerate.project.code': 'Code',
  'dealGenerate.project.codePlaceholder': 'e.g. ROS-2026-02',
  'dealGenerate.project.client': 'Client',
  'dealGenerate.project.clientLocked': 'From the deal, locked.',
  'dealGenerate.project.pm': 'PM',
  'dealGenerate.project.status': 'Status',
  'dealGenerate.project.statusNote': 'Created as active.',
  'dealGenerate.project.period':
    'Start and end come from the first and last day of the chosen line items: {period}. The team is built from the matches in step 4.',
  'dealGenerate.project.periodNone':
    'The chosen line items carry no dates: the project starts today and has no end. The team is built from the matches in step 4.',
  'dealGenerate.existing.label': 'Project',
  'dealGenerate.existing.pick': 'Choose a project',
  'dealGenerate.existing.note': "The deal client's projects.",
  'dealGenerate.existing.empty':
    'This client has no projects. Go back and choose “No project, under the client”.',

  'dealGenerate.contract.type': 'Contract type',
  'dealGenerate.contract.typeNote': 'Pre-filled from the revenue schedule: {mode}.',
  'dealGenerate.contract.name': 'Contract name',
  'dealGenerate.lines.col.line': 'Deal line item',
  'dealGenerate.lines.col.type': 'Type',
  'dealGenerate.lines.col.target': 'Contract line item',
  'dealGenerate.lines.col.hours': 'Hours',
  'dealGenerate.lines.col.amount': 'Amount',
  'dealGenerate.lines.option': 'option',
  'dealGenerate.lines.skipped': 'skipped',
  'dealGenerate.lines.folded': 'Milestone: {name}',
  'dealGenerate.lines.toggle': 'Carry over: {name}',
  'dealGenerate.lines.empty': 'The deal has no line items — the contract is created without any.',
  'dealGenerate.milestones.title': 'Milestones: {count}',
  'dealGenerate.milestones.asLineItems': 'Milestone = contract line item',
  'dealGenerate.milestones.asTasks':
    'Milestone = task in the project (0 estimate, due on its date)',
  'dealGenerate.milestones.tasksNeedProject':
    'This route has no project, so no milestone tasks are created.',
  'dealGenerate.preview':
    '1 contract ({type}) · line items: {lines} · Σ {revenue} revenue · Σ {hours} estimate.',

  'dealGenerate.match.empty':
    'The deal has no placeholders — no allocations are created. You can plan the work later on the project’s Resources tab.',
  'dealGenerate.match.pick': 'Choose a person',
  'dealGenerate.match.aria': 'Who takes it: {name}',
  'dealGenerate.match.headcount': '{count} people',
  'dealGenerate.match.sum':
    'Matched: {people} people · {hours} allocated. Hard bookings, Monday to Friday, in the planned weeks; an unmatched placeholder gets no booking.',
  'dealGenerate.match.noProject':
    'This route has no project, so no allocations are created — the matches are not carried over.',
  'dealGenerate.match.projectOnly':
    'Project only: allocations hang off a contract line item, so none are created. You can plan the work later on the project’s Resources tab.',
  'dealGenerate.summary.title': 'What gets created?',
  'dealGenerate.summary.project': 'Project',
  'dealGenerate.summary.projectExisting': 'Existing: {name}',
  'dealGenerate.summary.projectNone': 'None — under the client',
  'dealGenerate.summary.contract': 'Contract',
  'dealGenerate.summary.contractValue': '{type} · line items: {lines}',
  'dealGenerate.summary.revenue': 'Revenue',
  'dealGenerate.summary.estimate': 'Estimate',
  'dealGenerate.summary.tasks': 'Milestone tasks',
  'dealGenerate.summary.allocations': 'Allocations',
  'dealGenerate.summary.people': 'People: {count}',
  'dealGenerate.summary.pieces': '{count}',
  'dealGenerate.summary.stepwise':
    'The parts are made one after another: if one is refused, what was made before it stays and is linked to the deal.',

  'dealGenerate.error.project': 'Enter the project name and the PM.',
  'dealGenerate.error.existing': 'Choose a project.',
  'dealGenerate.error.contract': 'Enter the contract name.',
  'dealGenerate.partial.title': 'What was made stays, and is linked to the deal:',
  'dealGenerate.partial.none': 'Nothing was created.',
  'dealGenerate.partial.hint':
    'You can finish the rest with Generate more — do not generate what already exists again.',
  'dealGenerate.done.title': 'Done — {deal}',
  'dealGenerate.done.lead': 'The deal stays, and points back to what was created.',
  'dealGenerate.done.project': 'Project',
  'dealGenerate.done.openProject': 'Open project',
  'dealGenerate.done.contract': 'Contract',
  'dealGenerate.done.openContract': 'Open contract',
  'dealGenerate.done.lineItems': 'Contract line items',
  'dealGenerate.done.tasks': 'Milestone tasks',
  'dealGenerate.done.allocations': 'Weekly bookings',
};
